import { MAP_GEOMETRY_TYPE, mapGeometryTypeIconMap } from "Common/dictionaries/mapGeometryType";
import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "map";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const ZOOM = {
    MIN: 1,
    MAX: 15,
    DEFAULT: 3,
    EQUIVALENT_100: 5
};
export const ZOOM_VALUES = [1, 3, 5, 7.5, 10, 12.5, 15];
export const MODE = {
    VIEW: 1,
    ADDING_LOCATION_POINT: 2,
    ADDING_LOCATION_LINE: 3,
    ADDING_LOCATION_AREA: 4,
    ADDING_LOCATION_POINT_ON_GRAPH: 5
};
export const MODE_ICONS = {
    [MODE.ADDING_LOCATION_POINT]: "icon-location-anchor",
    [MODE.ADDING_LOCATION_LINE]: mapGeometryTypeIconMap[MAP_GEOMETRY_TYPE.LINE],
    [MODE.ADDING_LOCATION_AREA]: mapGeometryTypeIconMap[MAP_GEOMETRY_TYPE.AREA],
    [MODE.ADDING_LOCATION_POINT_ON_GRAPH]: "icon-location-anchor"
};
export const MAX_RESOLUTION_SHOW_NAMES = 1500;
export const localStorageHideHintMessageKey = "ohotnik.map.hint.hide";
